import {
  GETSETUPPARTYTYPES,
  CREATESETUPPARTYTYPES,
  UPDATESETUPPARTYTYPES,
  DELETESETUPPARTYTYPES,
} from "../actions/types";

const initialState = {};

// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, action) {
  switch (action.type) {
    // Setup partyTypeList Cases
    case GETSETUPPARTYTYPES:
      return {
        ...state,
        partyTypeList: action.payload.data,
      };
    case CREATESETUPPARTYTYPES:
      return {
        ...state,
        setuppartyTypeListCreateStatus: action.payload.success,
      };
    case UPDATESETUPPARTYTYPES:
      return {
        ...state,
        setuppartyTypeListUpdateStatus: action.payload.success,
      };
    case DELETESETUPPARTYTYPES:
      return {
        ...state,
        setuppartyTypeListDeleteStatus: action.payload.success,
      };

    default:
      return state;
  }
}
